import styled from 'styled-components';

interface IProps {
    left: number;
}

import { DIVIDER_WIDTH } from '../../constants';

export const Divider = styled.div.attrs((props: IProps) => ({
    style: {
        left: `${props.left}%`,
    },
}))<IProps>`
    width: ${DIVIDER_WIDTH}px;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #fff;
`;
